import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterCheckbox } from './filters/filter_checkbox';
import { Filters } from '../../../../constants/filter/filters';
import TranslationContainer from '../../../translation/translation_container';

function Features(props) {
    const opened = props.opened || props.runflatValue;

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-features'
            containerModifier="features"
        >
            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.runflatEnabled ?
                        'catalog-filters-rft-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.RUN_FLAT}
                    checked={props.runflatValue}
                    labelTranslationKey={'catalog-filters-runflat-label'}
                    tooltipContent="will-be-replace"
                    onChange={props.onRunflatChange}
                    onToolTipHover={() => props.onToolTipHover('Runflat')}
                    disabled={!props.runflatEnabled}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Features.propTypes = {
    runflatEnabled: PropTypes.bool.isRequired,
    runflatValue: PropTypes.bool.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onRunflatChange: PropTypes.func.isRequired,
};

export { Features };
